import { Box } from '@mui/material';
import React from 'react';

import GridLayout from 'layouts/GridLayout';

import CertificateInfo from './CertificateInfo';
import UpdateCertificateInfo from './UpdateCertificateInfo';

const CertificateInfoStep = ({ onSubmit, artwork, isPending, certificateFormState }) => {
  return (
    <Box sx={{ pt: 3 }}>
      <GridLayout>
        <CertificateInfo
          onSubmit={onSubmit}
          artwork={artwork}
        />
        <UpdateCertificateInfo
          artwork={artwork}
          isPending={isPending}
          certificateFormState={certificateFormState}
        />
      </GridLayout>
    </Box>
  );
};

export default CertificateInfoStep;
